import React, { useEffect, useState } from 'react';
import Layout from '../Layout';
import { Typography, Container, Box, Grid } from '@material-ui/core';
import { getAllPM_logs } from '../../ReduxStore/PreventiveMaintaince/CreatePMPlan';
import { useDispatch } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CustomBreadcrumbs from '../Breadcrumb';
import { convertUTCtoIST } from '../../helpers/DateConvert';
import { useNavigate } from 'react-router-dom';
import { GridLoadingSpinner } from '@tmlconnected/avant-garde-components-library';

const ApproveChecksheet = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const breadcrumbsLinks = [
        { label: 'Home', href: '/' },
        { label: ' Preventive Maintenance', href: '/preventive-maintenance' }
    ];
    const [loading, setLoading] = useState(true);
    const [checkSheets, setChecksheets] = useState([]);

    const checksheetHandler = (item) => {
        // console.log("checksheet:", item)
        navigate(`/preventive-maintenance/checksheet/${item.plan_id}/${item.frequency}/${item.current_plan_date}`)
    }


    const getPMCheckSheet = async () => {
        try {
            const action = dispatch(getAllPM_logs("?approval_pending=true"));
            const res = await action.unwrap();
            setChecksheets(res.result.PM_log_table);
        } catch (error) {
            toast.error(error.message || "No Logs Found!");
        }
    }


    useEffect(() => {
        const fetchData = async () => {
            await getPMCheckSheet();
            setLoading(false);
        };
        fetchData();
    }, [])

    if (loading) {
        return (
          <Layout>
            <Container>
              <Box mt={4} display="flex" justifyContent="center" alignItems="center" minHeight="80vh" >
                <GridLoadingSpinner />
              </Box>
            </Container>
          </Layout>
        );
      }



    return (
        <Layout>
            <Container>
                <Box mt={1}>
                    <Typography variant="h4" component="h1" gutterBottom>
                        Approve Checksheet
                    </Typography>
                </Box>
                <Box mb={2}>
                    <CustomBreadcrumbs links={breadcrumbsLinks} current="Approve Checksheet" />
                </Box>
                <Box>
                    {checkSheets && checkSheets.length === 0 ? (
                        <Box display="flex" alignItems="center" justifyContent="center" mt={4}>
                            <Typography variant="h5">No Record found</Typography>
                        </Box>
                    ) : (
                        <Grid container spacing={3}>
                            {checkSheets && checkSheets.map((item, index) => (
                                <Grid item className='PM' xs={3} key={index}>
                                    <div className='card' onClick={() => { checksheetHandler(item) }}
                                    >
                                        <p>{item.machine_details.asset_text} ({item.machine_details.asset_no})</p>
                                        <p>Frequency: {item.frequency}</p>
                                        <p>Done by: {item.done_by}</p>
                                        <p>Approval User: {item?.approved_by || "--"}</p>
                                        <p>CheckPoints Completed: {convertUTCtoIST(item.last_activity_time)}</p>
                                    </div>
                                </Grid>
                            ))}
                        </Grid>
                    )
                    }

                </Box>
            </Container>
            <ToastContainer />
        </Layout>
    );
};

export default ApproveChecksheet;
